import { Injectable } from "@angular/core";
import { ReplaySubject } from "rxjs";
import { StorageService } from "../storage.service";

const STORAGE_KEY_PREFIX = "HUB.CORANCHERS.ALL.TENANTS";

@Injectable({
  providedIn: "root",
})
export class TenantStorageService {
  allTenants: string | any;
  allTenants$: ReplaySubject<string> = new ReplaySubject<string>(1);

  constructor(private storage: StorageService) {
    this.init();
  }

  async init() {
    let tenants: string;
    tenants = await this._getTenants();
    this.allTenants = tenants;
    this.allTenants$.next(tenants);
  }

  private async _getTenants(): Promise<string> {
    return this.storage.get(`${STORAGE_KEY_PREFIX}`);
  }

  async setTenants(tenants: string | any) {
    let key = `${STORAGE_KEY_PREFIX}`;
    if (tenants == null) {
      this.allTenants = null;
      await this.storage.remove(key);
    } else {
      this.allTenants = tenants;
      await this.storage.set(key, tenants);
    }
    this.allTenants$.next(tenants);
  }
}
